import React ,{useEffect,useState} from "react"
import axios from "axios"
import Cookies from "js-cookie"
import { MenuItem, FormControl, Select, makeStyles } from "@material-ui/core"
import { SetCookies } from "../../../../_helpers/Cookies"
import { IVPCURRENCY } from "../../../../../env_config"
import { FaInfoCircle } from 'react-icons/fa';
import {OverlayTrigger,Tooltip} from "react-bootstrap";
import { NODE_API_URL } from "../../../../../env_config"
import getSymbolFromCurrency from "currency-symbol-map"

const useStyles = makeStyles((theme) => ({
    formControl: {
      margin: theme.spacing(1),
      minWidth: 120,
    },
    selectEmpty: {
      marginTop: theme.spacing(2),
    },
  }));
export default function MultiCurrency(props){
    const classes = useStyles();
    const [currValueInr,setCurrValueInr] = React.useState(81.36);
    // const [currValueUsd,setCurrValueUsd] = React.useState(1);
    const [currency, setCurrency] = React.useState('cur_usd');
    const [currencies,setCurrencies] = React.useState([])
    const [disabledropdown,setDisableDropdown] = useState(false)
    const handleChange = (event) => {
      axios({
        method: "POST",
        url: `${NODE_API_URL}/INTL/updateWebsiteCurrency`,
        headers: {
            "Content-Type": "application/json",
        },
        data: {
          user_id:props.userinfo.id,
          currency:event.target.value
        },
     }).then(response => {
          if(response && response.data){
            setCurrency(event.target.value)
            SetCookies("currency",event.target.value)
            window.location.reload(false);
          }
     })
    }
    useEffect(() => {
            axios({
                method: "GET",
                url: `${NODE_API_URL}/INTL/fetch-currency`,
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${Cookies.get("cust_auth_token")}` 
                },
            }).then(response => {
                if(response && response.data && response.data.data){
                    setCurrencies(response.data.data)
                }
            })
    },[])
    useEffect(() => {
      axios({
          method: "POST",
          url: IVPCURRENCY,
          headers: { "Content-Type": "application/json" },
      }).then(response => {
          if(response && response.data && response.data.data){
             //  console.log(response.data.data,"response.data.data")
              response.data.data[0].cur_usd = 1
              SetCookies("conversionrates",JSON.stringify(response.data.data))
          }
      })
},[])
    // useEffect(() => {
    //   // console.log(window.location.pathname,"window.location.href")
    //   if(window.location.pathname === '/search-result/N' || window.location.pathname === '/search-result/L' || window.location.pathname === '/search-grid/N'  || window.location.pathname === '/search-grid/L'){
    //     setDisableDropdown(true)
    //   }
    //   else{
    //     setDisableDropdown(false)
    //   }
    // },[window.location.href])
    useEffect(() => {
      setCurrency(props.userinfo.websitecurrency)
    },[props.userinfo])
    // console.log(currencies,"currencies")
    const getsymbol = (responsecurrency) => {
      const currencyCode = responsecurrency.replace("cur_", "").toUpperCase();
      let symbol = getSymbolFromCurrency(currencyCode)
      return symbol
    }
    return(
        <div className="align-self-center multiCurrencyBox mr-2">
           <div className="d-flex align-items-center position-relative">
              <FormControl className={`${classes.formControl} multi_currency_dropdown`}>
               {/* <InputLabel id="multi_currency">Currency</InputLabel> */}
                <Select
                  labelId="multi_currency"
                  id="multi_currency"
                  value={currency}
                  onChange={handleChange}
                  disabled={disabledropdown}
                >
                  {/* <MenuItem value={"cur_inr"}>INR-{currValueInr}</MenuItem>  
                  <MenuItem value={"cur_usd"}>USD-{currValueUsd}</MenuItem> */}
                  {currencies.map(((values,i) => (
                    <MenuItem  key={i} value={values.currencyname}>{values.currname} {values.currsymbol}  {values.currencyvalue}</MenuItem>
                  )))}
                </Select>
              </FormControl>
              <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip" >Exchange rate shown here are for reference, All purchase and payments will be in US$</Tooltip>} >
                  <span><FaInfoCircle className="text-dark cursor-pointer multiCurrencyIcon text-hover-primary"/></span>
              </OverlayTrigger>
           </div>
        </div>
    )
}